var _Grid$Container;

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Separator } from "../../../../../../../Common";
import { Modal, ModalHeader } from "../../../../../../../Utils";
import { Grid } from "../../../../../..";
import Services from '../../../../../Services';
import styles from './ServicesModal.scss';

var ServicesModal = function ServicesModal(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose;

  var _useTranslation = useTranslation(['headerUi']),
      t = _useTranslation.t;

  return /*#__PURE__*/React.createElement(Modal, {
    isOpened: isOpen,
    onClose: onClose,
    isPadded: false,
    header: /*#__PURE__*/React.createElement(Grid.Container, null, /*#__PURE__*/React.createElement(ModalHeader, {
      onCancel: onClose,
      title: t('SERVICES')
    }), /*#__PURE__*/React.createElement(Separator, {
      className: styles.topSeparator,
      marginTop: 0,
      marginBottom: 0
    }))
  }, _Grid$Container || (_Grid$Container = /*#__PURE__*/React.createElement(Grid.Container, null, /*#__PURE__*/React.createElement(Services, null), /*#__PURE__*/React.createElement(Separator, {
    marginTop: 0,
    marginBottom: 0
  }))));
};

export default ServicesModal;